import { BrandModel } from '@/models/tables/brand.model';
import { RentalPracticeModel } from '@/models/rental-practice.model';

export class RentalReservationModel {
  public id: number;
  public marca: BrandModel;
  public dataInizio: Date;
  public dataFine: Date;
  public rentalPractice: RentalPracticeModel;
  public veicoloPrenotazioneLibera: string;
  public bpCliente: number;
  public denominazioneCliente: string;
  public indirizzoCliente: string;
  public cittaCliente: string;
  public telefonoCliente: string;
  public emailCliente: string;
  public note: string;
  public creator: string;
  public created: Date;
  public modifier: string;
  public modified: Date;
}
